<template>
  <div>
    <div class="flex flex-col items-center justify-center space-y-5 md:space-y-8">
      <LoadingCircle class="h-24 w-24 text-gray-700" />
      <div class="mb-6 flex flex-col justify-center text-center text-blue-brand-700">
        <div class="font-medium tracking-wide text-gray-700">
          <span v-if="mensaje">{{ mensaje }}</span>
          <span v-else>Cargando...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['mensaje'],

  data() {
    return {}
  },
}
</script>

<style></style>
